import { getBoxX, getBoxZ } from "../shape/Intersect";


// Compress用、境界box群を生成(輪切り線代わり)
// mesh: 投影するオブジェクト
// return: [[min_x, max_x, min_y, max_y, z]]
export function GetBounds(mesh, interval, extention, line_count, offset, compression){
  mesh.geometry.computeBoundingBox();
  const min_z = mesh.geometry.boundingBox.min.z;
  var bounds = [];

  const z0 = min_z + offset;
  const b0 = getBoxZ(mesh, z0);
  const z0a = min_z - extention + offset;
  const b0a = [b0[0], b0[1], b0[2], b0[3], z0a];
  bounds.push(b0a);

  for(var i=1; i<=line_count; i++){
    const z = (i <= 1) 
    ? min_z - extention + interval*i + offset
    : min_z + interval*i + offset;

    const b = getBound(mesh, z, compression[i-1]);
    bounds.push(b);
  }
  return bounds;
}

function getBound(mesh, z, comp){
  const [min_x, max_x, min_y, max_y] = getBoxZ(mesh, z);
  if(comp == 100) return [min_x, max_x, min_y, max_y, z];

  const cx = (min_x + max_x) / 2;
  const cy = (min_y + max_y) / 2;
  const absx = max_x - min_x;
  const absy = max_y - min_y;
  const dx = absx * comp / 200;
  const dy = absy * comp / 200;
  const min_x0 = cx - dx;
  const max_x0 = cx + dx;
  const min_y0 = cy - dy;
  const max_y0 = cy + dy;
  return [min_x0, max_x0, min_y0, max_y0, z];
}
